module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personinfo"
  }, [_c('mt-header', {
    staticClass: "fixedtop",
    attrs: {
      "title": _vm.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.back($event)
      }
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infobody"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aboutMe),
      expression: "aboutMe"
    }],
    attrs: {
      "id": "desc",
      "name": "text",
      "placeholder": "请输入个人简介"
    },
    domProps: {
      "value": (_vm.aboutMe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.aboutMe = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("100-1000")])]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("下一步")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlebox",
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('h1', [_vm._v("个人简介")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0c0e4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/my/personinfo.vue
// module id = 1264
// module chunks = 1